import { render, staticRenderFns } from "./createRatePlan.vue?vue&type=template&id=912a55b4"
import script from "./createRatePlan.vue?vue&type=script&lang=js"
export * from "./createRatePlan.vue?vue&type=script&lang=js"
import style0 from "./createRatePlan.vue?vue&type=style&index=0&id=912a55b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports